import { Skeleton } from '@nextui-org/react';

const ContentSkeleton = () => {
  return (
    <div>
      <Skeleton className="h-10 rounded-[100px]" />
      <div className="mt-5 flex justify-end">
        <Skeleton className="h-10 w-[390px] rounded-[100px]" />
        <Skeleton className="ml-3 h-10 w-[200px] rounded-[100px]" />
        <Skeleton className="ml-3 h-10 w-[90px] rounded-[100px]" />
      </div>
      <div className="-mx-2 mt-5 flex">
        <div className="w-[20%] px-5">
          <Skeleton className="mb-4 h-[100px] w-full rounded-2xl" />
          <Skeleton className="mb-4 h-[240px] w-full rounded-2xl" />
        </div>
        <div className="w-[20%] px-2">
          <Skeleton className="mb-4 h-[320px] w-full rounded-2xl" />
          <Skeleton className="mb-4 h-[120px] w-full rounded-2xl" />
        </div>
        <div className="w-[20%] px-2">
          <Skeleton className="mb-4 h-[200px] w-full rounded-2xl" />
          <Skeleton className="mb-4 h-[240px] w-full rounded-2xl" />
        </div>
        <div className="w-[20%] px-2">
          <Skeleton className="mb-4 h-[240px] w-full rounded-2xl" />
          <Skeleton className="mb-4 h-[150px] w-full rounded-2xl" />
        </div>
        <div className="w-[20%] px-2">
          <Skeleton className="mb-4 h-[120px] w-full rounded-2xl" />
          <Skeleton className="mb-4 h-[160px] w-full rounded-2xl" />
        </div>
      </div>
    </div>
  );
};

export default ContentSkeleton;
